import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useIntl } from "react-intl";
import { IconArrowRight } from "../../../assets/icons/icon";
import { BASE_URL_SUPPORT } from "../../../constants/endpoints";
import Pagination from "../../../common/components/pagination/pagination";
import { useStoreActions, useStoreState } from "easy-peasy";

const InsightsSearch = ({ currentTab, results, textSearch }) => {
  const { formatMessage } = useIntl();
  const { data, total } = results;

  const [infoPage, setInfoPage] = useState({
    MaxResultCount: 6,
    page: 1,
    SkipCount: 0,
  });

  const getPage = (page) => {
    setInfoPage({
      ...infoPage,
      page,
      SkipCount: (page - 1) * infoPage.MaxResultCount,
    });
  };

  const getSize = (size) => {
    setInfoPage({
      ...infoPage,
      MaxResultCount: size,
    });
  };

  const getArticleSearchResults = useStoreActions(
    (action) => action.insights.fetchArticleSearchResults
  );

  const articleSearch = useStoreState((state) => state.insights?.articleSearch);

  useEffect(() => {
    getArticleSearchResults({
      text: textSearch,
      tab: currentTab,
      page: infoPage.page,
    });
  }, [currentTab, getArticleSearchResults, infoPage.page]);

  if (data.length === 0) {
    return (
      <section className="insights-more">
        <div className="search_results_content">
          <p> Results for {`"${articleSearch.keyword}"`} </p>
          <p>Sorry. There are no results for {`"${articleSearch.keyword}"`}</p>
          <p>Try rewording your query, or browse through our site.</p>
        </div>
      </section>
    );
  }

  return (
    <section className="insights-more">
      <h3 className="more-header">Results</h3>
      <div className="more-wrap-item divider-60">
        {data.map((item, index) => (
          <article className="more-item" key={item.id}>
            <Link to={`/${currentTab}/article/${item.attributes.slug}`}>
              <img
                src={`${BASE_URL_SUPPORT}${item.attributes.image.data.attributes.url}`}
                alt=""
                className="divider-24"
              />
            </Link>
            <p className="insights-tag divider-20">{currentTab}</p>
            <Link to={`/${currentTab}/article/${item.attributes.slug}`}>
              <h5>{item.attributes.title}</h5>
            </Link>
            <p className="more-short-desc divider-20">
              {item.attributes.seo?.metaDescription}
            </p>
          </article>
        ))}
      </div>

      <Pagination
        getPage={getPage}
        getSize={getSize}
        numberPerPage={infoPage.MaxResultCount}
        totalValue={total}
        currentPage={
          (infoPage.SkipCount + infoPage.MaxResultCount) /
            infoPage.MaxResultCount -
          1
        }
      />
    </section>
  );
};

export default InsightsSearch;
